// extracted by mini-css-extract-plugin
module.exports = {"rowIconText":"Careteam_rowIconText__2-3tH","rowIcon":"Careteam_rowIcon__3_8zy","entryRow":"Careteam_entryRow__2xFkz"};